var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icofont/sent") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Zeplin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Specs"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tokens-/-icons-/-message-/-sent",
    filter: ""
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.6259623,3.08397485 C14.8557266,2.73932834 15.3213786,2.64619793 15.6660251,2.87596228 C15.9793402,3.08483896 16.0847906,3.48866411 15.9287487,3.81929865 L15.8740377,3.91602515 L9.87403772,12.9160251 C9.65038341,13.2515066 9.20731701,13.3453585 8.87046838,13.1470249 L8.78147871,13.0856516 L5.03147871,10.0856516 C4.70803226,9.82689445 4.65559123,9.35492517 4.91434839,9.03147871 C5.14958218,8.73743649 5.56102432,8.66736568 5.87689801,8.85146372 L5.96852129,8.91434839 L9.079,11.403 L14.6259623,3.08397485 Z",
    id: "Path-2",
    fill: "#828282",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSent);
export default __webpack_public_path__ + "static/media/sent.ebec46fb.svg";
export { ForwardRef as ReactComponent };